(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("FEGOVue"), require("FEGORender"));
	else if(typeof define === 'function' && define.amd)
		define(["FEGOVue", "FEGORender"], factory);
	else if(typeof exports === 'object')
		exports["/fego/component/quotes-small-card/render"] = factory(require("FEGOVue"), require("FEGORender"));
	else
		root["/fego/component/quotes-small-card/render"] = factory(root["FEGOVue"], root["FEGORender"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__29666__, __WEBPACK_EXTERNAL_MODULE__85322__) => {
return 